import React from "react";

import { Link } from "react-router-dom";

const DashboardServices = () => {
  return (
    // <div id="solutions">
    //   <div className="flex flex-col-reverse sm:flex-row px-4 sm:px-12 mt-24 sm:mt-5 items-center ">
    //     <div className="bg-white rounded-lg p-5 sm:p-10 border-[1px] shadow-lg ">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold drop-shadow-2xl">
    //         Expert <span className="text-orange-400">Web Development</span>{" "}
    //         Services Tailored to Your Vision
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Crafting your digital masterpiece begins with our expert{" "}
    //         <b>web development services</b> , meticulously tailored to your
    //         unique vision. From captivating <b>website design</b> to seamless{" "}
    //         <b>website development</b> , and even strategic{" "}
    //         <b>website redesign</b> , our team of skilled <b>web developers</b>{" "}
    //         specializes in bringing your online dreams to life. Whether you're
    //         launching a <b>new venture</b> or <b>enhancing</b> your{" "}
    //         <b>e-commerce</b>
    //         presence , trust us to deliver a tailored solution that sets you
    //         apart. Elevate your online presence today with our comprehensive
    //         expertise
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/web-development">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //     <img src={web} />
    //   </div>

    //   <div className="flex flex-col sm:flex-row px-4 sm:px-12 mt-2 sm:mt-5 items-center ">
    //     <img src={db} />
    //     <div className="bg-white rounded-lg p-5 sm:p-10 border-[1px] shadow-lg b">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold">
    //         Seamless <span className="text-orange-400">Database Migration</span>{" "}
    //         Solutions for Optimal Data Transition
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Experience a seamless transition with our expert database migration
    //         solutions. Our team of <b>database experts</b> specializes in{" "}
    //         <b>application migration , cloud migration</b> , and{" "}
    //         <b>data migration</b> , ensuring a smooth and efficient transfer of
    //         your valuable data. With our deep <b>database expertise</b> , we
    //         handle every aspect of the migration process, from planning to
    //         execution, ensuring minimal disruption to your operations. Trust us
    //         to deliver reliable <b>database transfer</b> solutions tailored to
    //         your unique needs. Make your migration journey hassle-free with our
    //         proven expertise.
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/database-migration">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //   </div>

    //   <div className="flex flex-col-reverse sm:flex-row px-4 sm:px-12 mt-2 sm:mt-5 items-center ">
    //     <div className="bg-white rounded-lg border-[1px] p-5 sm:p-10 shadow-lg">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold">
    //         Empowering Informed Decision-Making with{" "}
    //         <span className="text-orange-400">BI Analytics</span> Excellence
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Empower your organization with informed decision-making using our
    //         trusted BI analytics platform. Our <b>Power BI Service</b> provides
    //         comprehensive <b>data analytics</b> and <b>business intelligence</b>{" "}
    //         solutions, enabling you to harness the power of data management for
    //         strategic insights. With our powerful software, you can unlock{" "}
    //         <b>company analytics</b> , streamline <b>business intelligence</b> ,
    //         and drive efficient
    //         <b>business analytics</b> . Trust our expertise in{" "}
    //         <b>BI intelligence</b> to transform your data into actionable
    //         insights and propel your business forward. Experience the difference
    //         with our <b>trusted analytics platform</b> today.
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/bi-analytics">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //     <img src={bi} />
    //   </div>

    //   <div className="flex flex-col sm:flex-row px-4 sm:px-12 mt-2 sm:mt-5 items-center ">
    //     <img src={cloud_mgmt_home} />
    //     <div className="bg-white rounded-lg p-5 sm:p-10 border-[1px] shadow-lg bo">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold">
    //         <span className="text-orange-400">Cloud Managed Services</span> :
    //         Seamless, Secure, Scalable Solutions
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Transform your business with our comprehensive{" "}
    //         <b>Cloud Managed Services</b> , leveraging our expertise in{" "}
    //         <b>AWS Web Services</b> and <b>Amazon Cloud Services</b> . From
    //         optimizing your <b>cloud environment</b> to ensuring the{" "}
    //         <b>security</b> of your <b>cloud server</b> , our solutions cover
    //         every aspect of your <b>cloud computing</b> needs. With a focus on
    //         seamless
    //         <b>cloud-to-cloud migration</b> and <b>optimization</b> , we
    //         prioritize security in the cloud to safeguard your data and
    //         operations. Whether it's
    //         <b>
    //           Infrastructure as a Service (IaaS), Platform as a Service (PaaS)
    //         </b>{" "}
    //         , or <b>Software as a Service (SaaS)</b> , trust us to elevate your
    //         business in the cloud environment with our managed services
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/cloud-management">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //   </div>

    //   <div className="flex flex-col-reverse sm:flex-row px-4 sm:px-12 mt-2 sm:mt-5 items-center ">
    //     <div className="bg-white rounded-lg border-[1px] p-5 sm:p-10 shadow-lg ">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold">
    //         Strategic{" "}
    //         <span className="text-orange-400">
    //           Strategic Cloud Consultation
    //         </span>{" "}
    //         : Elevate Your Business in the Cloud
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Empower your business growth with Flint specialized{" "}
    //         <b>Cloud Consulting services</b> , meticulously crafted to meet your
    //         unique requirements and propel your success in the digital realm.
    //         From navigating <b>cloud architectures</b> to ensuring{" "}
    //         <b>cloud computing security</b> , we provide comprehensive guidance
    //         to maximize your <b>AWS Web Services</b> and{" "}
    //         <b>Amazon Cloud Services</b> utilization. Our expertise extends to{" "}
    //         <b>Google Cloud Platform</b> , offering insights into{" "}
    //         <b>Google Cloud Computing Platform</b>
    //         and <b>services on AWS</b> . With a focus on optimizing{" "}
    //         <b>cloud-to-cloud</b>
    //         interactions, we help you harness the full potential of{" "}
    //         <b>AWS Cloud Technologies</b> and seamlessly integrate them into
    //         your operations. Experience the power of{" "}
    //         <b>cloud in cloud computing</b> with our trusted consultancy.
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/cloud-consultation">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //     <img src={cloud_consult} />
    //   </div>

    //   <div className="flex flex-col sm:flex-row px-4 sm:px-12 mt-2 sm:mt-5 items-center ">
    //     <img src={cloud_migr} />
    //     <div className="bg-white rounded-lg p-5 sm:p-10 border-[1px] shadow-lg bo">
    //       <p className="text-xl sm:text-3xl font-notosans font-semibold">
    //         Simplifying <span className="text-orange-400">Cloud Migration</span>{" "}
    //         with Managed Services
    //       </p>
    //       <p className="text-sm sm:text-lg mt-5 font-notosans">
    //         Streamline your cloud migration journey with our <b>Cloud Managed
    //         Services</b> , leveraging the expertise of <b>AWS Web Services</b> and <b>Amazon
    //         Cloud Services</b> . From seamless <b>cloud-to-cloud</b> migration to ensuring
    //         robust security in the cloud, we specialize in optimizing every
    //         aspect of your transition. Our comprehensive approach to <b>cloud
    //         computing</b> security spans <b>Infrastructure as a Service (IaaS),
    //         Platform as a Service (PaaS), and Software as a Service (SaaS)</b>
    //         solutions within the <b>AWS Cloud Computing environment</b> . Trust us to
    //         navigate the complexities of cloud migration while ensuring your
    //         data and operations remain secure.
    //       </p>
    //       <p className="mt-5">
    //         <Link to="/cloud-migration">
    //           <Button variant="outlined">Explore Details</Button>
    //         </Link>
    //       </p>
    //     </div>
    //   </div>
    // </div>

    <div id="solutions" className="pt-12">
      <p className="text-center text-[#333e49] mt-20 sm:mt-0 text-2xl sm:text-4xl poppins-semibold">
        Prime Offerings: Our Featured Services
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 overflow-hidden gap-16 px-9 sm:p-14 mt-5 sm:mt-0">
        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-violet-200 to-pink-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-red-700">
                Web Development
              </h2>
              <p className="text-black poppins-regular italic">
                Expert Web Development Services Tailored to Your Vision
              </p>
            </div>
          </div>
          <div className="mt-4">
            {/* <p className="text-4xl font-bold text-white">22°C</p>
          <div className="flex items-center justify-between gap-1">
            <span className="mr-2 text-neutral-800">Feels Like</span>
            <span className="text-white">20°C</span>
          </div>
          <div className="flex items-center justify-between gap-1">
            <span className="text-neutral-800">Wind</span>
            <span className="text-white">10 km/h</span>
          </div>
          <div className="flex items-center justify-between gap-1">
            <span className="text-neutral-800">Humidity</span>
            <span className="text-white">75%</span>
          </div> */}

            <p className="text-black">
              Transform your online presence with our expert web development
              services. From captivating design to seamless development, our
              skilled team brings your vision to life. Elevate your digital
              brand today with our tailored solutions.
            </p>

            <Link to="/web-development">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>

        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-blue-200 to-cyan-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-green-800">
                Database Migration
              </h2>
              <p className="text-black poppins-regular italic">
                Seamless Database Migration Solutions for Optimal Data
                Transition
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-black">
              Effortlessly migrate your data with our expert solutions,
              specializing in application, cloud, and data migration. Our
              database experts ensure a seamless transfer, handling every aspect
              from planning to execution. Trust us for reliable and tailored
              database migration, making your journey hassle-free.
            </p>

            <Link to="/database-migration">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>

        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-red-200 to-orange-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-amber-950">
                BI Analytics
              </h2>
              <p className="text-black poppins-regular italic">
                Empowering Informed Decision-Making with BI Analytics Excellence
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-black">
              Elevate decision-making with our Power BI Service, offering robust
              business intelligence solutions for strategic insights. Unlock
              company analytics, streamline BI, and drive efficient business
              analytics. Trust our expertise to transform data into actionable
              insights, propelling your business forward
            </p>
            <Link to="/bi-analytics">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>

        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-amber-200 to-yellow-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-slate-900">
                Cloud Management
              </h2>
              <p className="text-black poppins-regular italic">
                Cloud Managed Services : Seamless, Secure, Scalable Solutions
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-black">
              Elevate your business with our AWS and Amazon Cloud Services
              expertise. Our comprehensive Cloud Managed Services prioritize
              security, seamless cloud-to-cloud migration, and optimization.
              Trust us for IaaS, PaaS, and SaaS solutions, ensuring your data
              and operations thrive in the cloud.
            </p>
            <Link to="/cloud-management">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>

        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-lime-200 to-lime-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-blue-950">
                Cloud Migration
              </h2>
              <p className="text-black poppins-regular italic">
                Simplifying Cloud Migration with Managed Services
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-black">
              Optimize your cloud migration with our AWS and Amazon Cloud
              Services expertise. We specialize in seamless transitions,
              ensuring robust security across IaaS, PaaS, and SaaS solutions.
              Trust us to navigate complexities, securing your data in the AWS
              Cloud Computing environment.
            </p>
            <Link to="/cloud-migration">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>

        <div className="group hover:-rotate-0 [transform:rotate3d(1_,-1,_1,_15deg)] duration-500 overflow-hidden bg-gradient-to-r from-purple-300 to-purple-200 p-6 rounded-lg hover:shadow-lg [box-shadow:12px_12px_0px_0px_#8b8787] backdrop-filter backdrop-blur-md border border-neutral-600">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold poppins-regular text-yellow-500">
                Cloud Consultation
              </h2>
              <p className="text-black poppins-regular italic">
                Strategic Strategic Cloud Consultation : Elevate Your Business
                in the Cloud
              </p>
            </div>
          </div>
          <div className="mt-4">
            <p className="text-black">
              Elevate your business with Flint's specialized Cloud Consulting.
              We tailor solutions for optimal AWS and Google Cloud utilization,
              ensuring secure and seamless integration. Unlock the full
              potential of cloud computing for growth and efficiency.
            </p>
            <Link to="/cloud-consultation">
              <button className="bg-red-950 text-white border border-red-400 border-b-4 font-medium overflow-hidden relative px-4 py-2 rounded-md hover:brightness-150 hover:border-t-4 hover:border-b active:opacity-75 outline-none duration-300 group mt-3 w-full">
                <span className="bg-red-400 shadow-red-400 absolute -top-[150%] left-0 inline-flex w-80 h-[5px] rounded-md opacity-50 group-hover:top-[150%] duration-500 shadow-[0_0_10px_10px_rgba(0,0,0,0.3)]"></span>
                Explore
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardServices;
